export default __webpack_public_path__ + "static/media/Truck.6f3b32f6.svg";